import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { FadeUp, MaskedLines, SectionLabel } from "../components/Reveal";
import StatusBadge from "../components/StatusBadge";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const SECTIONS = [
    {
        title: "1. Éditeur du site",
        body: [
            "Le site serrurierparis.paris est édité par la société SEMI FERMETURE SASU, société par actions simplifiée unipersonnelle au capital de 2 000 euros.",
            "Siège social : 43 rue de la Condamine, 75017 Paris.",
            "SIRET : 841 344 450 00017 — SIREN : 841 344 450 — TVA intracommunautaire : FR48841344450.",
            "Directeur de la publication : Issam Bel Hadj Saad.",
            "Contact : " + EMAIL + " — Tél. : " + PHONE_DISPLAY + " (24h/24 — 7j/7).",
        ],
    },
    {
        title: "2. Hébergement",
        body: [
            "Le site est hébergé par OVH SAS, société par actions simplifiée au capital de 10 174 560 €, immatriculée au RCS de Lille Métropole.",
            "Siège social : 2 rue Kellermann, 59100 Roubaix, France — Tél. : 09 72 10 10 07.",
        ],
    },
    {
        title: "3. Propriété intellectuelle",
        body: [
            "L'ensemble des contenus du site (textes, images, illustrations, logo, charte graphique) est la propriété exclusive de SEMI FERMETURE SASU, sauf mention contraire. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
            "Les marques de serrurerie citées (Fichet, Bricard, JPM, Vachette, DOM, Reelax…) ainsi que les compagnies d'assurance mentionnées appartiennent à leurs propriétaires respectifs et ne sont citées qu'à titre indicatif.",
        ],
    },
    {
        title: "4. Données personnelles (RGPD)",
        body: [
            "Les informations recueillies via le formulaire de demande de devis (nom, téléphone, email, description du besoin) sont utilisées exclusivement pour traiter votre demande et vous recontacter. Elles ne sont ni vendues, ni cédées à des tiers.",
            "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression des données vous concernant. Pour l'exercer, contactez-nous par téléphone ou via le formulaire de contact.",
            "Les données sont conservées pour une durée maximale de 3 ans à compter du dernier contact.",
        ],
    },
    {
        title: "5. Cookies",
        body: [
            "Le site peut utiliser des cookies techniques strictement nécessaires à son fonctionnement, ainsi que des cookies de mesure d'audience anonymisés. Vous pouvez configurer votre navigateur pour refuser tout ou partie des cookies.",
        ],
    },
    {
        title: "6. Tarifs et devis",
        body: [
            "Les tarifs affichés sur le site sont indiqués TTC et donnés à titre informatif. Conformément à la réglementation, tout devis est gratuit et sans engagement ; un devis écrit est systématiquement établi avant toute intervention.",
            "En cas d'intervention d'urgence, un document devis/facture détaillant la main d'œuvre et les pièces est remis au client avant paiement.",
        ],
    },
    {
        title: "7. Responsabilité",
        body: [
            "SEMI FERMETURE SASU s'efforce d'assurer l'exactitude des informations diffusées sur le site, sans pouvoir en garantir l'exhaustivité. L'éditeur ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site.",
        ],
    },
];

export default function MentionsLegales() {
    return (
        <div data-testid="mentions-legales-page">
            <SEO
                title="Mentions Légales — Serrurier Paris | Éditeur, RGPD, Tarifs"
                description="Mentions légales du site serrurierparis.paris : éditeur SEMI FERMETURE SASU, hébergeur OVH, SIRET 84134445000017, données personnelles (RGPD), cookies et conditions tarifaires."
                path="/mentions-legales"
            />

            <section className="grain relative overflow-hidden bg-midnight py-10 text-white md:py-16">
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <nav className="mb-8 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/50" data-testid="breadcrumb">
                        <Link to="/" className="transition-colors hover:text-gold">Accueil</Link>
                        <span>/</span>
                        <span className="text-gold">Mentions légales</span>
                    </nav>
                    <SectionLabel dark>Informations légales</SectionLabel>
                    <StatusBadge className="mt-6" />
                    <h1 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
                        <MaskedLines delay={0.15} lines={["Mentions légales."]} />
                    </h1>
                </div>
            </section>

            <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 md:py-24">
                <div className="space-y-12">
                    {SECTIONS.map((s, i) => (
                        <FadeUp key={s.title} delay={0.05}>
                            <article data-testid={`legal-section-${i}`}>
                                <h2 className="font-display text-2xl font-semibold tracking-tight">{s.title}</h2>
                                <div className="mt-4 space-y-3">
                                    {s.body.map((p, j) => (
                                        <p key={j} className="leading-relaxed text-midnight/70">
                                            {p}
                                        </p>
                                    ))}
                                </div>
                            </article>
                        </FadeUp>
                    ))}
                </div>
                <FadeUp delay={0.1}>
                    <p className="mt-14 border-t border-midnight/10 pt-8 text-sm text-midnight/50">
                        Une question sur ces mentions ? Contactez-nous au{" "}
                        <a href={PHONE_TEL} className="font-semibold text-emergency underline">{PHONE_DISPLAY}</a>.
                    </p>
                </FadeUp>
            </section>
        </div>
    );
}
